<template lang="pug">
	.v-image-slider-vertical.image-slider-vertical(:class="['image-slider--' + mode, {'loading': loading, 'image-slider--full': slider && slider.items && slider.items.length > 1}]")
		.image-slider__slider(v-if="slider && slider.items && slider.items.length")
			template(v-if="slider.button" )
				button.image-slider-vertical__gallery-btn(type="button" @click="openGallery" v-if="mode === 'regular' && slider.button.open" :aria-label="slider.button.open?.ariaLabel")
					v-svg-icon.image-slider-vertical__gallery-icon(:icon="slider.button.open.icon")
			.image-slider-vertical__slider-counter
				v-svg-icon.image-slider-vertical__slider-counter-icon(:icon="slider.icons.camera")
				.image-slider-vertical__slider-counter-text {{ slidesCounter }}

			.image-thump-slider__arrow.image-thump-slider__arrow--prev(ref="prev-thump" :class="{'hidden': hideThumbs}")
				v-svg-icon.image-thump-slider__arrow-icon(icon="slide-down")
			.image-thump-slider__arrow.image-thump-slider__arrow--next(ref="next-thump" :class="{'hidden': hideThumbs}")
				v-svg-icon.image-thump-slider__arrow-icon(icon="slide-up")
			.image-slider-vertical__container
				.image-slider-vertical__container-main
					.image-slider-vertical__arrow.image-slider-vertical__arrow--prev(ref="prev")
						v-svg-icon.image-slider-vertical__arrow-icon(icon="slide-left")
					.image-slider-vertical__arrow.image-slider-vertical__arrow--next(ref="next")
						v-svg-icon.image-slider-vertical__arrow-icon(icon="slide-right")
					v-swiper-slider.image-slider-vertical__main-slider(v-if="slider && slider.items && slider.items.length"
						:options="options"
						:navigation="navigation"
						:pagination="pagination"
						@slide-change="onSlideChange"
						@swiper="onSwiper")
						template(v-for="(slide, index) in slider.items" :key="index")
							v-swiper-slide
								.image-slider-vertical__item
									template(v-if="slide.type === 'video'")
										.image-slider-vertical__iframe-wrap
											v-video.image-slider__video(:type="slide.type" :src="slide.link" :poster="slide.link")
									template(v-else-if="slide.type === 'youtube'" )
										.image-slider-vertical__iframe-wrap
											v-video.image-slider__video(:type="slide.type" :src="slide.link" :poster="slide.src")
									template(v-else)
										img.image-slider-vertical__image(:src="slide.src" :alt="slide.alt")
				.image-slider-vertical__container-thumps(:class="{'hidden': hideThumbs}")
					v-swiper-slider.image-slider__thumps-slider(v-if="slider && slider.items && slider.items.length"
						:options="thumpsOptions"
						:navigation="navigationThumbs"
						:direction="direction"
						@swiper="onSwiperThumbs")
						template(v-for="(slide, index) in slider.items" :key="index")
							v-swiper-slide(@click="slideToIndex(index)")
								.image-slider-vertical__thumbs
									template(v-if="slide.type === 'video'")
										video.image-slider-vertical__thumb(:src="slide.link" :alt="slide.alt")
										.video__btn
											v-svg-icon.video__btn-icon(icon="play-btn")
									template(v-else-if="slide.type === 'youtube'" )
										img.image-slider-vertical__thumb(:src="slide.src" :alt="slide.alt")
										.video__btn
											v-svg-icon.video__btn-icon(icon="play-btn")
									template(v-else)
										img.image-slider-vertical__thumb(:src="slide.src" :alt="slide.alt")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId';
import {SwiperSlide} from 'swiper/vue';
import breakpoints from '../scripts/breakpoints';
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	emits: [
		'open-gallery'
	],

	props: {
		mode: {
			type: String,
			default: 'regular'
		},

		title: {
			type: String,
			default: null
		},

		initialIndex: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			newOptions: null,
			isMdTimeout: null,
			thumbsSwiper: null,
			mainSwiper: null,
			activeIndex: 0,
			options: {
				slidesPerView: 1,
				spaceBetween: 10,
				loop: false,
				initialSlide: this.initialIndex,
				breakpoints: {
					// when window width is >= x
					[breakpoints['xl-min']]: {
						spaceBetween: 4
					},
					[breakpoints['lg-min']]: {
						spaceBetween: 4
					},
					[breakpoints['sm-min']]: {
						spaceBetween: 4,
						pagination: {
							clickable: true,
						},
					}
				}
			},
			thumpsOptions: {
				slidesPerView: 4,
				spaceBetween: 5,
				watchOverflow: true,
				breakpoints: {
					[breakpoints['md-min']]: {
						spaceBetween: 4
					},
					[breakpoints['sm-min']]: {
						slidesPerView: 3,
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 2,
					},
				}
			},
			navigation: false,
			navigationThumbs: false,
			pagination: false,
			direction: 'vertical',
			hideThumbs: false
		};
	},

	watch: {
		isSm() {
			if(this.isSm) {
				this.direction = 'horizontal'
			} else {
				this.direction = 'vertical'
			}
		},

		is3Xs() {
			if(this.is3Xs) {
				this.hideThumbs = true
			} else {
				this.hideThumbs = false
			}
		}
	},

	methods: {


		onSwiper(slider) {
			this.mainSwiper = slider;
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		onSwiperThumbs(slider) {
			this.thumbsSwiper = slider;
			this.navigationThumbs = {
				prevEl: this.$refs['prev-thump'],
				nextEl: this.$refs['next-thump']
			}
		},

		onSlideChange(slider) {
			this.activeIndex = slider.realIndex;
			this.thumbsSwiper.slideTo(slider.realIndex);
		},

		slideToIndex(index) {
			this.activeIndex = index;
			this.mainSwiper.slideTo(index);
		},

		openGallery() {
			this.$emit('open-gallery', this.activeIndex)
		},

		computedSourcesBig(item) {
			return [
				{
					'src': item.big,
					'size': '1x'
				},
				{
					'src': item.big_2x,
					'size': '2x'
				}
			];
		},

		dataSet(data) {
			this.slider = data;
			this.uniqueId = uniqueId('swiper-');
		}
	},


	computed: {
		slidesCounter() {
			return `${this.activeIndex + 1}/${this.slider.items.length}`
		}
	}
};
</script>